export const LANGUAGES = ["vi", "en", "ja"] as const;
export type Lang = (typeof LANGUAGES)[number];

export const LANG_LABELS: Record<Lang, string> = {
  vi: "VI",
  en: "EN",
  ja: "JA",
};
